type ToastMessageProps = {
  message: string
}

const ToastMessage = ({ message }: ToastMessageProps) => {
  return (
    <>
      <div
        role="status"
        aria-live="polite"
        aria-atomic="true"
        className="flex w-full items-center justify-center rounded-lg bg-rl-gray-900/90 p-4 shadow-rl-emphasize"
      >
        <span className="font-rl-body2 whitespace-pre-line text-center text-rl-common-white">
          {message}
        </span>
      </div>
    </>
  )
}

export default ToastMessage
